import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { firebaseConfig } from './config';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';

@NgModule({
  imports: [AngularFireModule.initializeApp(firebaseConfig)],
  exports: [AngularFireModule, AngularFireAuthModule],
})
export class FirebaseModule {}
